module.exports = __webpack_public_path__ + "img/i_fxsy_djs.9aaab0b5.png";